import { MARKDOWN_RETRIEVE_BINDING } from "./markdownRetrieveCapability";
import { RETRIEVAL_VECTOR_KB_BINDING } from "./vectorKbCapability";

export type CapabilityBindingOption = {
  value: string;
  label: string;
  enabled: boolean;
};

export const CAPABILITY_BINDING_OPTIONS: CapabilityBindingOption[] = [
  {
    value: RETRIEVAL_VECTOR_KB_BINDING,
    label: "Fused hybrid retrieval",
    enabled: true,
  },
  {
    value: MARKDOWN_RETRIEVE_BINDING,
    label: "Markdown retrieval",
    enabled: true,
  },
  {
    value: "http.endpoint",
    label: "HTTP endpoint",
    enabled: false,
  },
];
